import { render, staticRenderFns } from "./MasterInfo.vue?vue&type=template&id=29f48164&scoped=true"
import script from "./MasterInfo.vue?vue&type=script&lang=js"
export * from "./MasterInfo.vue?vue&type=script&lang=js"
import style0 from "./MasterInfo.vue?vue&type=style&index=0&id=29f48164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f48164",
  null
  
)

export default component.exports